import { Skeleton } from '@shared/components/shadcn';

function LoadingMoreSkeleton() {
  return (
    <div className="relative h-[100px]">
      {[0, 1, 2].map(index => (
        <div
          key={index}
          className="absolute w-full"
          style={{
            transform: `translateY(${index * 12}px) scale(${1 - index * 0.04})`,
            zIndex: 3 - index,
          }}
        >
          <Skeleton className="isolate relative bg-background border border-border rounded-lg overflow-hidden">
            <div className={`p-5 flex items-center gap-5 ${index === 0 ? 'opacity-100' : 'opacity-0'}`}>
              <Skeleton className="size-10.5 rounded-full shrink-0" />
              <div className="w-full flex flex-col gap-2">
                <Skeleton className="h-5 w-32" />
                <Skeleton className="h-4 w-20" />
              </div>
              <Skeleton className="h-6 w-24 absolute top-0 right-0 rounded-r-none" />
            </div>
          </Skeleton>
        </div>
      ))}
    </div>
  );
}

export { LoadingMoreSkeleton };
